import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ScopeProvider } from "./context/ScopeContext";
import { Toaster } from "sonner";

import Welcome from "./pages/Welcome";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Movimientos from "./pages/Movimientos";
import Cuentas from "./pages/Cuentas";
import Proyeccion from "./pages/Proyeccion";
import Configuracion from "./pages/Configuracion";
import Recurrencias from "./pages/Recurrencias";
import Historial from "./pages/Historial";
import Categorias from "./pages/Categorias";
import AdminDashboard from "./pages/AdminDashboard";
import AppShell from "./components/layout/AppShell";

function FullscreenLoader() {
  return (
    <div className="fp-shell flex items-center justify-center" data-testid="auth-loading">
      <div className="flex flex-col items-center gap-3 text-soft">
        <div className="h-8 w-8 rounded-full border-2 border-sage-200 border-t-sage-900 animate-spin" />
        <p className="text-sm tracking-wider uppercase">Cargando FiPer</p>
      </div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullscreenLoader />;
  if (user === false) return <Navigate to="/welcome" state={{ from: location }} replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullscreenLoader />;
  if (user && user !== false) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <ScopeProvider>
        <BrowserRouter>
          <Toaster
            position="top-center"
            toastOptions={{
              classNames: {
                toast: "bg-white border border-line text-ink shadow-card rounded-2xl",
              },
            }}
          />
          <Routes>
            <Route path="/welcome" element={<PublicRoute><Welcome /></PublicRoute>} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />

            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/movimientos" element={<Movimientos />} />
              <Route path="/cuentas" element={<Cuentas />} />
              <Route path="/proyeccion" element={<Proyeccion />} />
              <Route path="/recurrencias" element={<Recurrencias />} />
              <Route path="/historial" element={<Historial />} />
              <Route path="/categorias" element={<Categorias />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/configuracion" element={<Configuracion />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ScopeProvider>
    </AuthProvider>
  );
}

export default App;
